import { StyledNavMenu } from "../../styles/StyledNav";
import { StyledLink } from "../../styles/Link";
import ProfileIcon from "../../assets/img/icons/profile.svg";
import NotificationIcon from "../../assets/img/icons/notification.svg";
import LogoutIcon from "../../assets/img/icons/logout.svg";
import AddIcon from "../../assets/img/icons/add-black.svg";
import { useAppContext } from "../../context/appContext";
import AuthService from "../../service/AuthSerivce";

export default function NavMenu() {
	const { items } = useAppContext();

	return (
		<StyledNavMenu>
			{/* {Object.keys(items.userUnits).length !== 0 && (
				<StyledLink to="/add-decision">
					<img src={AddIcon} alt="add-decision" />
				</StyledLink>
			)} */}
			<button>
				<img src={NotificationIcon} alt="notification" />
			</button>
			<StyledLink to={"/profile"}>
				<img src={ProfileIcon} alt="profile" />
				<span>{items?.userName && items?.userName}</span>
			</StyledLink>
			<div className="dropdown" onClick={() => AuthService.logout()}>
				<img src={LogoutIcon} alt="logout" />
				<span>Logout</span>
			</div>
		</StyledNavMenu>
	);
}
